import React, {Component} from "react";
import {route, routes} from "../../../vars/rd";

/**
 * 카테고리 버튼
 */
class CategoryBusiness extends Component {
    /** @var {function} */
    callback;

    constructor(props) {
        super(props);

        this.is_mine = props.is_mine || false;
        this.is_mypage = props.is_mypage || false;
        this.callback = props.onChange;

        this.state = {
            model: this.props.category
        }
    }

    componentDidMount() {
        this.mounted = true;
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        try {
            const prev_id = Number(prevProps.category.proid);
            const id = Number(this.props.category.proid);
            if(id !== prev_id) {
                this.setState({model: this.props.category});
            }
        } catch (e) {}
    }

    /**
     * @returns {DaoCategory}
     */
    get model() {
        return this.state.model;
    }

    /**
     * 클릭
     */
    changeCategory() {
        // if(!this.model.selected) {
            if(this.callback) this.callback(this.model);
            else route(routes.search_business, this.model.proid || this.model.code);
        // }
    }

    render() {
        if(this.is_mypage) {
            return (
                <div className="item">
                    <div className="icon">
                        <img src={this.model.image} alt={this.model.proname} />
                    </div>
                    <div className="name">{this.model.proname}</div>
                </div>
            );
        } else {
            return (
                <div className={`item ${this.model.selected ? 'on' : ''}`} role="tab" key={this.model.proid}>
                    <a onClick={() => this.changeCategory()}>
                        { this.is_mine ? <div className="mytype"><span>내 업종</span></div> : '' }
                        <div className="icon">
                            <span><img src={this.model.image} alt={this.model.proname} /> </span>
                        </div>
                        <div className="name">{this.model.proname}</div>
                    </a>

                </div>
            );
        }
    }
}

export default CategoryBusiness;


// WEBPACK FOOTER //
// ./src/pages/components/buttons/category.business.jsx